import React, { useContext, useState } from "react";
import LoginBg from "../../assets/images/login-bg.jpg";
import Logo from "../../assets/images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { isValidEmail } from "../../hooks/helper";
import { toast } from "react-toastify";
import { MyContext } from "../../hooks/MyContextProvider";
import { loginApi } from "../../Libs/api";
const Login = () => {
  const navigate = useNavigate();
  const { updateToken, updateUser, setLoading } = useContext(MyContext);
  const [inputData, setInputData] = useState({
    email: "",
    password: "",
  });
  const [inputDataError, setInputDataError] = useState({
    email: false,
    password: false,
  });

  const [show, setShow] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!inputData?.email) {
      setInputDataError({ ...inputDataError, email: true });
      toast.error("Please Enter a Email");
    } else if (!isValidEmail(inputData?.email)) {
      setInputDataError({ ...inputDataError, email: true });
      toast.error("Please Enter a Email in Proper Format");
    } else if (!inputData?.password) {
      setInputDataError({ ...inputDataError, password: true });
      toast.error("Please Enter a Password");
    } else if (inputData?.password?.length < 6) {
      toast.error("Please Enter a minimum 6 Characteristics");
      setInputDataError({ ...inputDataError, password: true });
    } else {
      setLoading(true);
      try {
        const apiCall = await loginApi(inputData);
        if (apiCall.status) {
          console.log(apiCall, "apiCall");

          setLoading(false);
          updateToken(apiCall?.data?.token);
          updateUser(apiCall?.data?.userDetails);
          // updateStep("step10")
          navigate("/");
        } else {
          setLoading(false);
          toast.error(apiCall?.message);
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
        toast.error("Something went wrong. Please try again later.");
      }
    }
  };

  return (
    <div class="container-fluid p-0">
      <div class="row">
        <div
          class="col-xl-7 b-center bg-size"
          style={{
            backgroundImage: `url(${LoginBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center center",
            display: "block",
          }}
        >
          {/* <img
            class="bg-img-cover bg-center"
            src="../assets/images/login/2.jpg"
            alt="looginpage"
            style="display: none"
          /> */}
        </div>
        <div class="col-xl-5 p-0">
          <div class="login-card login-dark">
            <div>
              <div>
                <Link class="logo text-start d-flex justify-content-center">
                  <img
                    class="img-fluid for-light"
                    src={Logo}
                    height={100}
                    width={180}
                    alt="looginpage"
                  />
                </Link>
              </div>
              <div class="login-main">
                <form
                  class="theme-form"
                  onSubmit={(e) => {
                    handleSubmit(e);
                  }}
                >
                  <h4>Sign in to account</h4>
                  <p>Enter your email &amp; password to login</p>
                  <div class="form-group">
                    <label class="col-form-label">Email Address</label>
                    <input
                      class={`${
                        inputDataError?.email ? "border border-danger" : ""
                      } form-control text-dark`}
                      type="email"
                      value={inputData?.email}
                      onChange={(e) => {
                        setInputData({
                          ...inputData,
                          email: e.target.value.toLowerCase(),
                        });

                        if (
                          e.target.value?.length >= 3 &&
                          isValidEmail(e.target.value)
                        ) {
                          setInputDataError({
                            ...inputDataError,
                            email: false,
                          });
                        } else {
                          setInputDataError({
                            ...inputDataError,
                            email: true,
                          });
                        }
                      }}
                      placeholder="Test@gmail.com"
                    />
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">Password</label>
                    <div class="form-input position-relative">
                      <input
                        class={`${
                          inputDataError?.password ? "border border-danger" : ""
                        } form-control text-dark`}
                        type={show ? "text" : "password"}
                        name="login[password]"
                        required=""
                        placeholder="*********"
                        value={inputData?.password}
                        onChange={(e) => {
                          setInputData({
                            ...inputData,
                            password: e.target.value,
                          });

                          if (e.target.value?.length >= 6) {
                            setInputDataError({
                              ...inputDataError,
                              password: false,
                            });
                          } else {
                            setInputDataError({
                              ...inputDataError,
                              password: true,
                            });
                          }
                        }}
                      />
                      <div class="show-hide">
                        {" "}
                        <span
                          class={`${show ? "" : "show"}`}
                          onClick={() => {
                            setShow(!show);
                          }}
                        ></span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group mb-0">
                    <button
                      class="btn btn-primary btn-block w-100"
                      type="submit"
                    >
                      Sign in
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
